/**
 * Top navigation bar — brand link, theme toggle, user email link, and sign-in.
 *
 * Renders on every authenticated page (mounted directly in each page
 * component rather than in a layout wrapper — see App.jsx). The brand
 * link always points to `/` (the project list), so it acts as a home
 * button throughout the application.
 *
 * Authenticated: email links to /settings page.
 * Unauthenticated: shows a "Sign in" link (edge case — Header is
 * only used on authed pages, but the guard is defensive).
 */
import { Link } from "react-router-dom";
import { isAuthenticated, isAdmin, getUserInfo, login } from "../services/auth.js";
import ThemeToggle from "./ThemeToggle.jsx";
import NotificationsBell from "./notifications/NotificationsBell.jsx";
import TenantSwitcher from "./TenantSwitcher.jsx";
import { COLLAB_MODE_ENABLED } from "../config.js";

export default function Header() {
  const authed = isAuthenticated();
  const user = authed ? getUserInfo() : null;
  // Super-admins need the tenant switcher on every page — not just under
  // AdminLayout — so the X-Tenant-Id header is always in scope when they
  // create projects or hit tenant-scoped routes from non-admin surfaces.
  const superAdmin = authed && isAdmin();

  return (
    <header className="header">
      <Link to="/" className="header-brand">
        AI <span className="accent">Coach</span>
      </Link>
      <div className="header-actions">
        {superAdmin && <TenantSwitcher />}
        <ThemeToggle />
        {authed && COLLAB_MODE_ENABLED && <NotificationsBell />}
        {authed ? (
          <>
            {user?.email && (
              <Link to="/settings" className="header-user header-user-link">
                {user.email}
              </Link>
            )}
          </>
        ) : (
          <button type="button" className="btn btn-primary" onClick={login}>
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}
